<template>
  <div class="sub-container">
    <div class="form-row-input" v-if="showRegNo">
      <ejs-textbox
        float-label-type="Always"
        placeholder="Reg No:"
        v-model="contact.regNo"
        :maxlength="50"
      />
    </div>

    <div class="form-row-input" :ref="`${applier}Name`">
      <ejs-combobox
        ref="contactNameField"
        float-label-type="Always"
        :dataSource="contactFieldDataSource"
        :fields="{ value: `name` }"
        :placeholder="namePlaceholder"
        data-test-contact-info="name"
        :value="nameVal"
        @change="splitName($event)"
        :maxlength="250"
        :cssClass="cssClass"
      />
      <label v-if="showErrorLabelName" class="e-error">This field is required</label>
    </div>

    <div class="form-row-input" :ref="emailClass">
      <scc-input-validator
        :rules="emailRules"
        :value="contact.email"
        :showErrorLabel="showErrorLabelEmail"
        :errorLabelMessage="errorLabelMessageEmail"
      >
        <ejs-textbox
          ref="email"
          :cssClass="cssClass"
          float-label-type="Always"
          :placeholder="emailPlaceholder"
          data-test-contact-info="email"
          v-model="contact.email"
          @input="onEmailInput($event.value)"
          :maxlength="250"
        />
      </scc-input-validator>
    </div>

    <div class="form-row-input" :ref="phoneClass">
      <scc-input-validator
        :rules="phoneRules"
        :value="contact.phone"
        :showErrorLabel="showErrorLabelPhone"
        :errorLabelMessage="errorLabelMessagePhone"
      >
        <ejs-textbox
          ref="phone"
          :cssClass="cssClass"
          float-label-type="Always"
          :placeholder="phonePlaceholder"
          data-test-contact-info="phone"
          :value="contact.phone"
          :maxlength="12"
          @input="formatPhoneNumber($event.value, 'phone')"
        />
      </scc-input-validator>
    </div>

    <div class="form-row-input" :ref="altPhoneClass">
      <scc-input-validator
        :rules="[phoneRule]"
        :value="contact.altPhone"
        :showErrorLabel="showErrorLabelAltPhone"
        :errorLabelMessage="errorLabelMessageAltPhone"
      >
        <ejs-textbox
          ref="altPhone"
          float-label-type="Always"
          :placeholder="altPhonePlaceholder"
          :value="contact.altPhone"
          :maxlength="12"
          @input="formatPhoneNumber($event.value, 'altPhone')"
        />
      </scc-input-validator>
    </div>
  </div>
</template>
<script>
import { phoneRule, emailRuleRegEx, phoneRuleRegEx } from '@/shared/constants';
import SccInputValidator from '../../../../components/base/scc-input-validator.vue';
import { applierTypeEnum } from '../constants';

export default {
  name: 'ContactInfo',

  props: {
    applier: String,
    phoneRules: Array,
    emailRules: Array,
    contact: Object,
    showRegNo: {
      type: Boolean,
      default: false,
    },
    contactFieldDataSource: Array,
  },

  components: {
    SccInputValidator,
  },

  data() {
    return {
      phoneRule,
      cssClass: null,
      contactNameLists: null,
      showErrorLabelPhone: false,
      showErrorLabelAltPhone: false,
      showErrorLabelEmail: false,
      errorLabelMessageEmail: null,
      errorLabelMessagePhone: null,
      errorLabelMessageAltPhone: null,
      showErrorLabelName: false,
    };
  },
  computed: {
    emailPlaceholder() {
      return `${this.applier} Email: ${
        this.applier === applierTypeEnum.APPLICANT ? '*' : ''
      }`;
    },
    phonePlaceholder() {
      return `${this.applier} Phone: ${
        this.applier === applierTypeEnum.APPLICANT ? '*' : ''
      }`;
    },
    altPhonePlaceholder() {
      return `${this.applier} Alt Phone:`;
    },
    namePlaceholder() {
      return `${this.applier} Name: ${
        this.applier === applierTypeEnum.APPLICANT ? '*' : ''
      }`;
    },
    nameVal() {
      return `${this.contact?.fName ?? ''} ${this.contact?.lName ?? ''}`;
    },
    emailClass() {
      return `${
        this.applier === applierTypeEnum.SITEOWNER
          ? 'owner'
          : this.applier.toLowerCase()
      }Email`;
    },
    phoneClass() {
      return `${
        this.applier === applierTypeEnum.SITEOWNER
          ? 'owner'
          : this.applier.toLowerCase()
      }Phone`;
    },
    altPhoneClass() {
      return `${
        this.applier === applierTypeEnum.SITEOWNER
          ? 'owner'
          : this.applier.toLowerCase()
      }AltPhone`;
    },
  },

  created() {
    if (this.applier === applierTypeEnum.APPLICANT) this.cssClass = 'required';
  },

  methods: {
    formatPhoneNumber(val, prop) {
      const phoneRef = `${prop}Class`;
      if ((prop === 'altPhone' && !val) || val.trim() === '') {
        this.showErrorLabelAltPhone = false;
        this.errorLabelMessageAltPhone = null;
        this.$refs[this[phoneRef]].classList.remove('e-error');
      }
      this.$emit('updateContactNumber', { prop, val });
      if (phoneRuleRegEx.test(this.contact[prop])) {
        this.$refs[this[phoneRef]].classList.remove('e-error');
        if (prop === 'altPhone') {
          this.showErrorLabelAltPhone = false;
          this.errorLabelMessageAltPhone = null;
        } else {
          this.showErrorLabelPhone = false;
          this.errorLabelMessagePhone = null;
        }
      }
    },
    splitName(e) {
      if (e?.e) {
        this.showErrorLabelName = (!e.value);
        if (e.value && this.$refs.ApplicantName) this.$refs.ApplicantName.classList.remove('e-error');
        this.$emit('updateContactInfo', { ...e.itemData });
      } else {
        this.showErrorLabelName = false;
      }
    },
    onEmailInput(value) {
      if (emailRuleRegEx.test(value)) this.$refs[this.emailClass].classList.remove('e-error');
      this.showErrorLabelEmail = false;
    },
  },
};
</script>
